import { statisticsEvent, mtaH5Click } from "@reco-w/core-ui";
import { menuLabel, getMenuTreeByCode } from "@reco-w/bitech-common";

import {
    ArticleCatalogueEnum,
    ARTICLE_COLUMN_BANNER_CODES,
    ARTICLE_COLUMN_BANNER_IMG,
    informationCenterCode,
} from "./common";

/**
 * 获取资讯数据目录名称
 * @param catalogueCode  数据目录代码
 * @returns
 */
export function getArticleText(catalogueCode) {
    switch (catalogueCode) {
        default:
            return "";
        case ArticleCatalogueEnum.article:
            return "动态资讯";
        case ArticleCatalogueEnum.notification:
            return "通知公告";
    }
}

/**
 * 获取资讯 Banner 栏目标题（仅中文，无英文副标题）
 * 有导航上一级时优先显示父级名（如书记班子 → 组织机构）
 * @param code 路由/数据目录 code（优先用 remap 前的路由 param）
 * @param options 资料中心 tag、详情兜底文案
 * @returns 栏目标题
 */
export function getArticleBannerTitle(
    code: string,
    options?: { tagValue?: string | number; tagName?: string; catalogueName?: string }
): string {
    // 资料中心详情 catalogueCode 常为 ZLZX，用 tagValue 还原子栏目 code 再查父级
    let lookupCode = code;
    if (code === ArticleCatalogueEnum.informationcenter && options?.tagValue != null && options.tagValue !== "") {
        const centerItem = informationCenterCode.find((e) => String(e.value) === String(options.tagValue));
        if (centerItem) {
            lookupCode = centerItem.code;
        }
    }

    // 子栏目页 Banner 显示导航上一级名称
    const parentTree = getMenuTreeByCode(lookupCode);
    if (parentTree && parentTree.length > 0) {
        return parentTree[0].label;
    }

    // 带 tagValue 筛选时优先显示标签名（如通知公告 → 青年夜校）
    if (options?.tagValue != null && options.tagValue !== "" && options?.tagName) {
        return options.tagName;
    }

    if (code && menuLabel[code]?.label) {
        return menuLabel[code].label;
    }

    // 资料中心无父级映射时的子栏目 fallback
    if (lookupCode !== code && menuLabel[lookupCode]?.label) {
        return menuLabel[lookupCode].label;
    }

    if (options?.tagName) {
        return options.tagName;
    }
    if (options?.catalogueName) {
        return options.catalogueName;
    }

    // 无栏目 code 时不渲染兜底文案，避免详情首屏闪「资讯」
    return "";
}

/**
 * 获取资讯 Banner 背景图路径
 * 指定栏目使用 column_banner；其余默认也统一为 column_banner（原 zixun 已停用）
 * @param code 路由/数据目录 code
 * @param options 资料中心 tagValue（可选）
 * @returns 背景图路径
 */
export function getArticleBannerImage(code: string, options?: { tagValue?: string | number }): string {
    if (code && ARTICLE_COLUMN_BANNER_CODES.includes(code as any)) {
        return ARTICLE_COLUMN_BANNER_IMG;
    }

    // 资料中心（路由 remap 后或详情 catalogueCode 为 ZLZX）统一用新图
    if (code === ArticleCatalogueEnum.informationcenter) {
        return ARTICLE_COLUMN_BANNER_IMG;
    }

    // 路由仍为子栏目 code、或带 tagValue 时一并覆盖
    if (options?.tagValue != null && options.tagValue !== "") {
        const centerItem = informationCenterCode.find((e) => String(e.value) === String(options.tagValue));
        if (centerItem && ARTICLE_COLUMN_BANNER_CODES.includes(centerItem.code as any)) {
            return ARTICLE_COLUMN_BANNER_IMG;
        }
    }

    // 默认统一使用 column_banner（原 ARTICLE_DEFAULT_BANNER_IMG / zixun.png）
    return ARTICLE_COLUMN_BANNER_IMG;
}

/**
 * 获取资讯埋点对应事件
 * @param catalogueCode 数据目录代码，获取埋点事件名前缀
 * @param map 埋点事件名其他部分
 * @returns statisticsEvent
 */
export function getArticleStaticsMap(catalogueCode, map) {
    const str = catalogueCode === ArticleCatalogueEnum.article ? "article" : catalogueCode === ArticleCatalogueEnum.notification ? "notification" : "";
    const eventMap = str + map;
    return statisticsEvent[eventMap];
}
/**
 * 资讯埋点
 * @param catalogueCode 数据目录代码，获取埋点事件名前缀
 * @param map 埋点事件名其他部分
 */
export function articleStatics(catalogueCode, map) {
    const event = getArticleStaticsMap(catalogueCode, map);
    mtaH5Click(event);
}
